module.exports = __webpack_public_path__ + "Roboto-Regular.df7b648ce5356ea1ebce.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/roboto/Roboto-Regular.ttf
// module id = 307
// module chunks = 2